export const HEADER = "طلبات التسوية";
export const BRIEF = "يمكنك الإطلاع على كل معاملاتك وتتبع حالتها أولا بأول.";
export const ACTIVE_SETTLEMENTS_TAB = "بإنتظار التسوية";
export const FINISHED_SETTLEMENTS_TAB = "تم التسوية";
export const BUTTON = {
  SEARCH: "البحث عن طريق رمز المعاملة",
  SEARCH_TRANS: "البحث عن طريق رمز الدفع",
  ALL_CASES: "جميع الحالات",
  START_DATE: "تاريخ البدء",
  END_DATE: "تاريخ الانتهاء",
};
